import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzBadgeModule } from '@blk/daisy/combinations/badge';
import { DzTooltipInjectorModule, DzTooltipModule } from '@blk/daisy/combinations/on-screen-help';
import { DzIconModule } from '@blk/daisy/core/icon';
import { DzPictogramsModule, dzSeek } from '@blk/daisy/core/pictograms';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { DzCheckboxModule } from '@blk/daisy/elements/selection-controls';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { DataServiceModule } from '@ddt-web/data-service';
import { DcrModule } from '@ddt-web/dcr';
import { DialogModule } from '@ddt-web/dialog';
import { DomModule } from '@ddt-web/dom';
import { CtaLinkModule } from '@ddt-web/elements';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';
import { faAngleDoubleLeft, faAngleDoubleRight, faBell, faUndo } from '@fortawesome/free-solid-svg-icons';
import { AgGridModule } from 'ag-grid-angular';

import { SelectColumnsComponent } from '../select-columns/select-columns.component';
import { TableCellModule } from '../table-cell/table-cell.module';
import { TableFormattingModule } from '../table-formatting';
import { AgGridTableComponent } from './ag-grid-table.component';
import { HeaderComponent, HeaderGroupCellRendererComponent } from './cell-renderers';
import { HeaderCellRendererComponent } from './cell-renderers/components/header-cell-renderer/header-cell-renderer.component';
import { ISharesCellRendererComponent } from './cell-renderers/components/ishares-cell-renderer/ishares-cell-renderer.component';
import { LightbulbCellRendererComponent } from './cell-renderers/components/lightbulb-cell-renderer/lightbulb-cell-renderer.component';
import { LinkCellRendererComponent } from './cell-renderers/components/link-cell-renderer/link-cell-renderer.component';
import { WorstOffenderBadgeCellRendererComponent } from './cell-renderers/components/worst-offender-badge-cell-renderer/worst-offender-badge-cell-renderer.component';
import { LoadingOverlayComponent } from './loading-overlay';
import { NoRowsOverlayComponent } from './no-rows-overlay/no-rows-overlay.component';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		TableCellModule,
		AgGridModule,
		CwpNgFrameworkModule,
		DataServiceModule,
		DzButtonModule,
		DzPictogramsModule.register(dzSeek),
		GenericDirectivesModule,
		DomModule,
		AnalyticsModule,
		CtaLinkModule,
		DzIconModule.withIcons(faAngleDoubleRight, faAngleDoubleLeft, faBell, faUndo),
		DzCheckboxModule,
		DcrModule,
		TableFormattingModule,
		DialogModule,
		DzBadgeModule,
		DzTooltipInjectorModule,
		DzTooltipModule
	],
	declarations: [
		AgGridTableComponent,
		HeaderCellRendererComponent,
		ISharesCellRendererComponent,
		SelectColumnsComponent,
		LightbulbCellRendererComponent,
		LinkCellRendererComponent,
		NoRowsOverlayComponent,
		HeaderGroupCellRendererComponent,
		HeaderComponent,
		LoadingOverlayComponent,
		WorstOffenderBadgeCellRendererComponent
	],
	exports: [AgGridTableComponent, SelectColumnsComponent, NoRowsOverlayComponent]
})
export class AgGridTableModule { }
